import { BiodirectNoDataIcon } from '@/shared/ui/assets';
import { NoDataComponent } from '@/shared/ui/components';
import { auth } from '@/shared/lib';
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';
import type { NotAvailableComponentProps } from './notAvailableComponent.types';

const NotAvailableComponent = ({
  containerClassName,
  message,
  hasLoginBanner,
}: NotAvailableComponentProps) => (
  <div
    className={classNames(containerClassName, 'not-available animated fadeIn', {
      'has-marketing-banner': auth.hasMarketingBanner() || auth.hasLogoBanner(),
      'has-login-banner': hasLoginBanner,
    })}
  >
    <div className="no-data-wrapper">
      <div className="no-data">
        <NoDataComponent
          message={message}
          icon={<ReactSVG src={BiodirectNoDataIcon} aria-hidden="true" />}
        />
      </div>
    </div>
  </div>
);

export default NotAvailableComponent;
